import { render, staticRenderFns } from "./ResourcesNcfIntro.vue?vue&type=template&id=96e2c8e0&"
import script from "./ResourcesNcfIntro.vue?vue&type=script&lang=js&"
export * from "./ResourcesNcfIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports